
import { AxiosResponse } from "axios";
import { HttpClient } from "helpers";
import { BaseResponseType, DataGridRequest, PagedResponseType } from "services/shared-models/sharedTypes";
import {
  CreateCourseOrderRefereeRequest,
  RefereeListResult,
  RefereeOrderEvaluationFormResult,
  RefereeResult,
  RefereeUserResult,
  ReferralOfRefereesRequest,
  RejectRefereeCourseOrderEvaluationFormRequest,
  ReturnedRefereeCourseOrderEvaluationFormRequest,
  SubmittedRefereeCourseOrderEvaluationFormRequest,
  ExaminerRewardApprovedRequest,
  UpdateExaminerAccreditationTypeRequest,
} from "./Model/RefereeTypes";
import {ExaminerOrderEvaluationFormResult} from "../examinersService/Model/ExaminerTypes";

export const RefereesService = {
  getAllReferees: async (dataGridRequest: DataGridRequest) => {
    return await HttpClient.post<PagedResponseType<RefereeUserResult>>(
      `/api/Referees/GetAllReferees`,
      dataGridRequest,
    );
  },
  getAllRefereesByCourseOrderId: async (courseOrderId: number) => {
    return await HttpClient.get<BaseResponseType<RefereeListResult[]>>(`/api/Referees/GetAllRefereesByCourseOrderId`, {
      params: {
        courseOrderId,
      },
    });
  },
  exportRefereesToExcelAsync: async (dataGridRequest: DataGridRequest) => {
    return await HttpClient.post<AxiosResponse<Blob>>(`/api/Referees/ExportRefereesToExcel`, dataGridRequest, {
      responseType: "blob",
    });
  },
  getRefereeOrderEvaluationForm: async (courseOrderId: number, courseOrderRefereeId: number) => {
    return await HttpClient.get<BaseResponseType<RefereeOrderEvaluationFormResult>>(
      `/api/Referees/GetRefereeCourseOrderEvaluationForm`,
      {
        params: {
          courseOrderId,
          courseOrderRefereeId,
        },
      },
    );
  },
  acceptRefereeOrderEvaluationForm: async (courseOrderRefereeId: number) => {
    return await HttpClient.put<BaseResponseType<RefereeOrderEvaluationFormResult>>(
      `/api/Referees/AcceptRefereeCourseOrderEvaluationForm/${courseOrderRefereeId}`,
    );
  },
  rejectRefereeOrderEvaluationForm: async (
      courseOrderRefereeId: number,
    { actionName, serialGuid, activityGuid }: RejectRefereeCourseOrderEvaluationFormRequest,
  ) => {
    return await HttpClient.put<BaseResponseType<RefereeOrderEvaluationFormResult>>(
      `/api/Referees/RejectRefereeCourseOrderEvaluationForm/${courseOrderRefereeId}`,
      {
        actionName,
        serialGuid,
        activityGuid
      },
    );
  },
  returnRefereeOrderEvaluationForm: async (
    courseOrderRefereeId: number,
    { actionName, serialGuid, recommendations, activityGuid }: ReturnedRefereeCourseOrderEvaluationFormRequest,
  ) => {
    return await HttpClient.put<BaseResponseType<RefereeOrderEvaluationFormResult>>(
      `/api/Referees/ReturnedRefereeCourseOrderEvaluationForm/${courseOrderRefereeId}`,
      {
        actionName,
        serialGuid,
        recommendations,
        activityGuid
      },
    );
  },
  submitRefereeOrderEvaluationForm: async (
    courseOrderRefereeId: number,
    request: SubmittedRefereeCourseOrderEvaluationFormRequest,
  ) => {
    return await HttpClient.put<BaseResponseType<RefereeOrderEvaluationFormResult>>(
      `/api/Referees/SubmittedRefereeCourseOrderEvaluationForm/${courseOrderRefereeId}`,
      request,
    );
  },
  referralOfReferees: async (request: ReferralOfRefereesRequest) => {
    return await HttpClient.put<BaseResponseType<RefereeResult>>(`/api/Referees/ReferralOfReferees`, request);
  },
  addReferee: async (request: CreateCourseOrderRefereeRequest[]) => {
    return await HttpClient.post<BaseResponseType<RefereeResult[]>>(`/api/Referees/AddReferee`, request);
  },
  deleteReferee: async (id: number) => {
    return await HttpClient.delete<BaseResponseType<RefereeResult>>(`/api/Referees/DeleteReferee`, {
      params: {
        id,
      },
    });
  },
  stopRefereeWorkflow: async (courseOrderRefereeId: number) => {
    return await HttpClient.put<BaseResponseType<RefereeResult>>(`/api/Referees/StopRefereeWorkflow/${courseOrderRefereeId}`);
  },

  refereeRewardApproved: async (courseOrderRefereeId: number, request: ExaminerRewardApprovedRequest) => {
    return await HttpClient.put<BaseResponseType<RefereeResult>>(
      `/api/Referees/RefereeRewardApproved/${courseOrderRefereeId}`,
      request,
    );
  },
  updateRefereeAccreditationType: async (
    courseOrderRefereeId: number,
    request: UpdateExaminerAccreditationTypeRequest,
  ) => {
    return await HttpClient.put<BaseResponseType<RefereeResult>>(
      `/api/Referees/UpdateRefereeAccreditationType/${courseOrderRefereeId}`,
      request,
    );
  },
  addRefereeAndAssign: async (request: ReferralOfRefereesRequest) => {
    return await HttpClient.post<BaseResponseType<any>>(`/api/Referees/AddRefereeAndAssign`, request);
  },
  refereeLastEvaluationHistory: async (courseOrderId: number) => {
    return await HttpClient.get<BaseResponseType<RefereeOrderEvaluationFormResult>>(
        `/api/Referees/GetRefereeLastEvaluationHistory`,
        {
          params: {
            courseOrderId,
          },
        },
    );
  },
};
